import { useState } from "react";
import { FiFilm } from "react-icons/fi";

/**
 * Image component with a styled placeholder fallback.
 * Shows a dark gradient placeholder with an icon when image fails to load or has no src.
 */
export default function ImageWithPlaceholder({
  src,
  alt = "",
  className = "",
  iconSize = 32,
  ...props
}) {
  const [failed, setFailed] = useState(false);

  if (!src || failed) {
    return (
      <div
        className={`bg-gradient-to-br from-dark-700 via-dark-600 to-dark-700 flex flex-col items-center justify-center gap-2 ${className}`}
        {...props}
      >
        <FiFilm size={iconSize} className="text-gray-600" />
        {alt && (
          <p className="text-[0.6rem] text-gray-600 text-center px-2 truncate max-w-full">
            {alt}
          </p>
        )}
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      loading="lazy"
      onError={() => setFailed(true)}
      {...props}
    />
  );
}
